/**
 * Copyright IBM Corp. 2022, 2026
 */

import slugify from 'slugify'
import { render as toPlainText } from 'datocms-structured-text-to-plain-text'
import {
	type Span,
	type StructuredText,
	isHeading,
} from 'datocms-structured-text-utils'

/**
 * Extracts the level 2 headings from a given Structured Text
 * content document, and returns objects passable to our
 * TableOfContents component for rendering.
 *
 * @param content Structured text content for a blog post
 * @returns An array of heading objects for use in TableOfContents
 */
export function getHeadingsFromStContent(content: StructuredText) {
	const stNodes = content.value.document.children || null

	return stNodes
		.map((node) => {
			if (isHeading(node) && node.level === 2) {
				const textNode = node.children[0] as Span
				const text = textNode.value
				const id = slugify(toPlainText(node), { lower: true })

				return {
					text,
					id,
				}
			}
		})
		.filter((node) => typeof node !== 'undefined')
}
